import { ScaleElement } from '@scale/base-element';
import { formatMoney } from '@scale/currency';
import { rollText } from '@scale/utilities';

class ProductPrice extends ScaleElement {
  #shownPrice;

  setup() {
    this.onVariantSelected((e) => this.#update(e.variant));
    this.onSubscriptionUpdated((e) => this.#update(e.variant));
  }

  #update(variant) {
    if (!variant) return;

    const price = this.ref('price');
    const compare = this.ref('compare-price');
    const badge = this.ref('sale-badge');
    const unit = this.ref('unit-price');

    if (price) {
      const next = formatMoney(variant.price);
      const shown = (price.lastElementChild ?? price).textContent.trim();
      if (this.#shownPrice !== undefined && next !== shown) {
        rollText(price, next, variant.price > this.#shownPrice ? 1 : -1);
      } else {
        price.textContent = next;
      }
      this.#shownPrice = variant.price;
    }

    const onSale = variant.compare_at_price > variant.price;

    if (compare) {
      compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      this.#reveal(compare, onSale);
    }

    if (price) price.classList.toggle('product-price__current--sale', onSale);

    if (badge) {
      if (onSale) {
        const saved = variant.compare_at_price - variant.price;
        const amount = badge.dataset.format === 'percentage'
          ? Math.round((saved * 100) / variant.compare_at_price)
          : formatMoney(saved);
        badge.textContent = badge.dataset.template.replace('[amount]', amount);
      }
      this.#reveal(badge, onSale);
    }

    if (unit && variant.unit_price) {
      unit.textContent = `${formatMoney(variant.unit_price)}/${variant.unit_price_measurement?.reference_unit || ''}`;
      unit.hidden = false;
    } else if (unit) {
      unit.hidden = true;
    }
  }

  #reveal(element, visible) {
    const appearing = visible && element.hidden;
    element.hidden = !visible;
    if (!appearing || !matchMedia('(prefers-reduced-motion: no-preference)').matches) return;
    const motion = getComputedStyle(element);
    element.animate([{ opacity: 0, translate: '0 6px' }, { opacity: 1, translate: '0 0' }], {
      duration: parseFloat(motion.getPropertyValue('--duration-normal')),
      easing: motion.getPropertyValue('--ease-spring'),
    });
  }
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
